import { render, staticRenderFns } from "./InstallationConfigList.vue?vue&type=template&id=252d57dc&"
import script from "./InstallationConfigList.vue?vue&type=script&lang=js&"
export * from "./InstallationConfigList.vue?vue&type=script&lang=js&"
import style0 from "./InstallationConfigList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports